import React from "react";
import PropTypes from "prop-types";
import "./card-panel.scss";

export default function CardPanel({
	noSpacing,
	smallSpacing,
	border,
	noShadow,
	...props
}) {
	return <div className={`panel-card-container`}>{props.children}</div>;
}
CardPanel.propTypes = {
	noSpacing: PropTypes.bool,
	smallSpacing: PropTypes.bool,
	border: PropTypes.bool,
	noShadow: PropTypes.bool,
	children: PropTypes.node.isRequired,
};
CardPanel.defaultProps = {
	noSpacing: false,
	smallSpacing: false,
	border: false,
	noShadow: false,
};
